import * as React from "react";

export const IconActionHTTP = (props: React.SVGProps<SVGSVGElement>): React.JSX.Element => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <g clipPath="url(#clip0_41279_38522)">
      <path
        d="M3.74967 9.16667H2.08301V7.5H0.833008L0.833008 12.5H2.08301L2.08301 10.4167H3.74967L3.74967 12.5H4.99967L4.99967 7.5H3.74967L3.74967 9.16667ZM5.83301 8.75L7.08301 8.75L7.08301 12.5H8.33301V8.75H9.58301V7.5L5.83301 7.5V8.75ZM10.4163 8.75H11.6663V12.5H12.9163V8.75H14.1663V7.5H10.4163V8.75ZM17.9163 7.5H14.9997V12.5H16.2497V10.8333H17.9163C18.583 10.8333 19.1663 10.25 19.1663 9.58333V8.75C19.1663 8.08333 18.583 7.5 17.9163 7.5ZM17.9163 9.58333H16.2497V8.75L17.9163 8.75V9.58333Z"
        fill="currentColor"
      />
    </g>
    <defs>
      <clipPath id="clip0_41279_38522">
        <rect width="20" height="20" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
